<template>
    <el-dialog :title="Object.keys(info).length === 0 ? '新增成就' : '修改成就'" :visible.sync="dialogVisible" width="700px" :before-close="handleClose">
        <el-form ref="form" size="small" :rules="rules" :model="form" label-width="100px">
            <el-form-item label="成就类型" prop="achievement_type">
                <el-select v-model="form.achievement_type" :placeholder="active_info.achievement_type.placeholder" :disabled="Object.keys(info).length > 0" style="width: 100%">
                    <el-option v-for="item of active_info.achievement_type.options" :key="item.value" :label="item.label_title" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="活动名称" prop="active_name">
                <el-input v-model="form.active_name" placeholder="请选择活动名称"></el-input>
            </el-form-item>

            <el-form-item label="徽章简述" prop="describe">
                <el-input type="textarea" v-model="form.describe" placeholder="请输入徽章简述"></el-input>
            </el-form-item>

            <el-form-item label="Explore简述" prop="remark">
                <el-input type="textarea" v-model="form.remark" placeholder="请输入Explore简述"></el-input>
            </el-form-item>

            <el-form-item label="达标数量" prop="amount">
                <el-input v-model="form.amount" placeholder="请输入达标数量" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="奖励积分" prop="point">
                <el-input v-model="form.point" placeholder="请输入奖励积分" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </el-form-item>

            <el-form-item label="活动状态">
                <el-switch v-model="form.status" active-color="#13ce66" active-text="打开" inactive-text="暂停" :active-value="activeValue" :inactive-value="inactiveValue"></el-switch>
            </el-form-item>

            <el-form-item class="add_active_footer">
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" v-if="Object.keys(info).length === 0" :loading="loading" @click="onSubmit">创建</el-button>
                <el-button type="primary" v-else :loading="loading" @click="onUpdata">更新</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import serverApi from '../../../server/index';
export default {
    props: ['dialogVisible', 'rule_list', 'info'],
    data() {
        return {
            active_info: {},
            form: {
                achievement_type: '', // achievement type
                type_name: '', // follow thirdapp

                active_type: 14,
                active_name: '',
                remark: '',
                describe: '',
                amount: '',
                point: '',
                status: 1,
            },
            loading: false,
            rules: {
                achievement_type: [{ required: true, message: '请选择成就类型', trigger: 'change' }],
                type_name: [{ required: true, message: '请选择平台', trigger: 'change' }],
                active_name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
                amount: [{ required: true, message: '请输入达标数量', trigger: 'blur' }],
                point: [{ required: true, message: '请输入奖励积分', trigger: 'blur' }],
                remark: [{ required: true, message: '请输入Explore简述', trigger: 'blur' }],
                describe: [{ required: true, message: '请输入徽章简述', trigger: 'blur' }],
            },
            activeValue: 1,
            inactiveValue: 0,
        };
    },
    methods: {
        onSubmit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    console.log('values', this.form);
                    const params = {
                        schema_name: this.active_info.schema_name,
                    };
                    Object.keys(this.form).forEach(ele => {
                        if (String(this.form[ele]).length > 0) {
                            if (ele === 'achievement_type') {
                                params['type_name'] = this.form[ele];
                            } else {
                                params[ele] = this.form[ele];
                            }
                        }
                    });
                    console.log('params', params);
                    params.amount = Number(params.amount);
                    params.point = Number(params.point);
                    this.loading = true;

                    serverApi
                        .addActive(params)
                        .then(res => {
                            if (res.data.code === 0) {
                                this.$message({
                                    message: '添加成功',
                                    type: 'success',
                                });
                                this.$emit('closeModal', true);
                            } else {
                                this.$message({
                                    message: res.data.msg || res.data.error,
                                    type: 'error',
                                });
                            }
                        })
                        .catch(e => {
                            this.$message({
                                message: e.data.error || e.data.msg,
                                type: 'error',
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onUpdata() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const params = {
                        schema_name: this.active_info.schema_name,
                    };
                    Object.keys(this.form).forEach(ele => {
                        if (this.form[ele] !== undefined && String(this.form[ele]).length > 0) {
                            if (ele === 'achievement_type') {
                                params['type_name'] = this.form[ele];
                            } else {
                                params[ele] = this.form[ele];
                            }
                        }
                    });
                    params.amount = Number(params.amount);
                    params.point = Number(params.point);
                    params.active_id = this.info.active_id;
                    this.loading = true;
                    console.log('params', params);

                    serverApi
                        .updataActive(params)
                        .then(res => {
                            if (res.data.code === 0) {
                                this.$message({
                                    message: '修改成功',
                                    type: 'success',
                                });
                                this.$emit('closeModal', true);
                            } else {
                                this.$message({
                                    message: res.data.msg || res.data.error,
                                    type: 'error',
                                });
                            }
                        })
                        .catch(e => {
                            this.$message({
                                message: e.data.error || e.data.msg,
                                type: 'error',
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleClose() {
            this.$emit('closeModal', false);
        },
    },
    created() {
        console.log('info', this.info);

        if (Object.keys(this.info).length === 0) {
            this.active_info = this.rule_list[0];
        } else {
            const { type_name, active_type, active_name, amount, point, status, remark, describe } = this.info;
            this.active_info = this.rule_list.find(ele => ele.active_type === active_type);
            this.form = {
                type_name: '',
                achievement_type: type_name,
                active_type,
                active_name,
                remark,
                describe,
                amount,
                point,
                status,
            };
        }
    },
};
</script>

<style lang="scss">
.add_active_footer {
    margin-top: 30px;
    button {
        width: 200px;
        margin-right: 30px;
        height: 35px;
        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
